import Theme from "../components/particles/Theme";

export const LINKS = {
  homepage: "/homepage",
  about: "/about",
  work: "/work",
  contact: "/contact",
};

export const SOCIAL_LINKS = {
  linkedIn: "https://www.linkedin.com/in/pavel-vondra-603012201/",
  instagram: "https://www.instagram.com/hatealgebra/",
  github: "https://github.com/hatealgebra",
};

export const EXTERNAL_LINKS = {
  weatherApp: "https://weather-application-pv.netlify.app",
  foodMood: "https://food-mood-pv.netlify.app",
};

export const BREAKPOINTS = {
  mobileL: 500,
  tablet: 786,
  laptop: 1024,
  desktop: 1440,
  highRes: 2560,
};
